import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import StoreLinks from './StoreLinks';
import LiveStatus from './LiveStatus';
import { SHOW_SUMMER_PASS, SHOW_MIDTERM_PASS, MIDTERM_PASS_LABEL } from '../utils/features';

/* ── SVG Icons ── */
const icons = {
  home: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  games: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="6" y1="11" x2="10" y2="11" /><line x1="8" y1="9" x2="8" y2="13" />
      <line x1="15" y1="12" x2="15.01" y2="12" /><line x1="18" y1="10" x2="18.01" y2="10" />
      <path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.544-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z" />
    </svg>
  ),
  pricing: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 2L3 14h9l-1 10 10-12h-9l1-10z" />
    </svg>
  ),
  grub: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8h1a4 4 0 0 1 0 8h-1" /><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
      <line x1="6" y1="1" x2="6" y2="4" /><line x1="10" y1="1" x2="10" y2="4" /><line x1="14" y1="1" x2="14" y2="4" />
    </svg>
  ),
  giftCards: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 12 20 22 4 22 4 12" /><rect x="2" y="7" width="20" height="5" />
      <line x1="12" y1="22" x2="12" y2="7" /><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
    </svg>
  ),
  tournaments: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" /><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" /><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2z" />
    </svg>
  ),
  faq: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  bookings: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
      <path d="M8 14h.01" /><path d="M12 14h.01" /><path d="M16 14h.01" />
      <path d="M8 18h.01" /><path d="M12 18h.01" />
    </svg>
  ),
  summerPass: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5" /><line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  ),
  contact: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  blog: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><line x1="10" y1="9" x2="8" y2="9" />
    </svg>
  ),
  gallery: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="m21 15-5-5L5 21" />
    </svg>
  ),
  championship: (
    <img src="https://whapaxxgaming.com/assets/gt7-battle-royale.png" alt="GT7" style={{ width: '100%', height: '100%', objectFit: 'contain', pointerEvents: 'none' }} />
  ),
};

/* ── Desktop dock items (Gift Cards & Bookings shown in top bar instead) ── */
const dockItems = [
  { to: '/',            label: 'Home',        icon: icons.home,        color: '#12d0ff' },
  { to: '/games',       label: 'Games',       icon: icons.games,       color: '#12d0ff' },
  { to: '/pricing',     label: 'Pricing',     icon: icons.pricing,     color: '#ffc857' },
  { to: '/game-day-grub',        label: 'Grub',        icon: icons.grub,        color: '#22c55e' },
  // Events tab hidden — route still live, links keep working
  { to: '/championships', label: '',  icon: icons.championship, color: '#ffc857' },
  { to: '/blog',           label: 'Blog',          icon: icons.blog,         color: '#8b5cf6' },
  { to: '/gallery',        label: 'Snaps',         icon: icons.gallery,      color: '#ff2d78' },
  { to: '/faq',            label: 'FAQ',            icon: icons.faq,          color: '#12d0ff' },
  { to: '/contact',        label: 'Contact',        icon: icons.contact,      color: '#12d0ff' },
];

/* ── Mobile menu items (includes Event Packages after Gift Cards) ── */
const mobileItems = [
  { to: '/',            label: 'Home',             icon: icons.home,        color: '#12d0ff' },
  { to: '/games',       label: 'Games',            icon: icons.games,       color: '#12d0ff' },
  { to: '/pricing',     label: 'Pricing',          icon: icons.pricing,     color: '#ffc857' },
  { to: '/game-day-grub',        label: 'Grub',             icon: icons.grub,        color: '#22c55e' },
  { to: '/gift-cards',  label: 'Gift Cards',       icon: icons.giftCards,   color: '#7b2dff' },
  ...(SHOW_MIDTERM_PASS ? [{ to: '/daypass', label: MIDTERM_PASS_LABEL, icon: icons.summerPass, color: '#f59e0b' }] : []),
  { to: '/party', label: 'Event Packages', icon: icons.bookings,    color: '#ff2d78' },
  ...(SHOW_SUMMER_PASS ? [{ to: '/summer-pass', label: 'Summer Day Pass',  icon: icons.summerPass,  color: '#f59e0b' }] : []),
  // Events tab hidden — route still live, links keep working
  { to: '/championships', label: '',     icon: icons.championship, color: '#ffc857' },
  { to: '/blog',           label: 'Blog',             icon: icons.blog,         color: '#8b5cf6' },
  { to: '/gallery',        label: 'Snaps',            icon: icons.gallery,      color: '#ff2d78' },
  { to: '/faq',            label: 'FAQ',              icon: icons.faq,          color: '#12d0ff' },
  { to: '/contact',        label: 'Contact',          icon: icons.contact,      color: '#12d0ff' },
];

export default function Navbar({ bannerOffset = 0 }) {
  const [scrolled, setScrolled] = useState(false);
  const [megaOpen, setMegaOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // close mega menu on route change
  useEffect(() => { setMegaOpen(false); }, [pathname]);

  // lock body scroll when mega menu is open
  useEffect(() => {
    if (megaOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [megaOpen]);

  /* Publish where the fixed header ends, as --wpxg-nav-bottom, so anything
     that sticks under it (the Grub menu filters) sits flush below it on
     either layout — the desktop header with its dock is far taller than the
     phone bar, and the announcement banner pushes both down. Measured, not
     guessed, because all three change. */
  const deskRef = useRef(null);
  const mobRef = useRef(null);
  useEffect(() => {
    const root = document.documentElement;
    const publish = () => {
      const el = [deskRef.current, mobRef.current].find(n => n && n.offsetHeight > 0);
      if (!el) return;
      const r = el.getBoundingClientRect();
      root.style.setProperty('--wpxg-nav-bottom', `${Math.max(0, Math.round(r.bottom))}px`);
    };
    publish();
    const ro = typeof window.ResizeObserver === 'function' ? new window.ResizeObserver(publish) : null;
    if (ro) { if (deskRef.current) ro.observe(deskRef.current); if (mobRef.current) ro.observe(mobRef.current); }
    window.addEventListener('resize', publish);
    return () => { if (ro) ro.disconnect(); window.removeEventListener('resize', publish); };
  }, [bannerOffset]);

  return (
    <>
      {/* ═══ DESKTOP: Top header with integrated HUD dock ═══ */}
      <header ref={deskRef} className="hide-mobile" style={{
        ...styles.desktopHeader,
        top: bannerOffset,
        ...(scrolled ? styles.desktopHeaderScrolled : {}),
      }}>
        <div style={styles.desktopTopRow}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <Link to="/" style={styles.logo}>
              <img src="/assets/whapaxx-logo-transparent.png" alt="Whapaxx Gaming" style={styles.logoImg} />
              <div style={styles.logoTextWrap}>
                <span style={styles.logoText}>WHAPAXX</span>
                <span style={styles.logoSub}>GAMING</span>
              </div>
            </Link>
            <LiveStatus variant="compact" />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <Link
              to="/gift-cards"
              style={{
                ...styles.giftCardsLink,
                ...(pathname === '/gift-cards' ? styles.giftCardsLinkActive : {}),
              }}
            >
              <span style={{ display: 'flex', transform: 'scale(0.8)' }}>{icons.giftCards}</span>
              <span>Gift Cards</span>
            </Link>
            {SHOW_MIDTERM_PASS && (
              <Link
                to="/daypass"
                style={{
                  ...styles.summerPassLink,
                  ...(pathname === '/daypass' ? styles.summerPassLinkActive : {}),
                }}
              >
                <span style={{ display: 'flex', transform: 'scale(0.8)' }}>{icons.summerPass}</span>
                <span>{MIDTERM_PASS_LABEL}</span>
              </Link>
            )}
            <Link
              to="/party"
              style={{
                ...styles.bookingsLink,
                ...(pathname === '/party' ? styles.bookingsLinkActive : {}),
              }}
            >
              <span style={{ display: 'flex', transform: 'scale(0.8)' }}>{icons.bookings}</span>
              <span>Event Packages</span>
            </Link>
            {SHOW_SUMMER_PASS && (
              <Link
                to="/summer-pass"
                style={{
                  ...styles.summerPassLink,
                  ...(pathname === '/summer-pass' ? styles.summerPassLinkActive : {}),
                }}
              >
                <span style={{ display: 'flex', transform: 'scale(0.8)' }}>{icons.summerPass}</span>
                <span>Summer Day Pass</span>
              </Link>
            )}
            <StoreLinks variant="smart" label="Get the App" style={{ fontSize: '0.8rem' }} />
          </div>
        </div>

        <nav style={styles.desktopDock}>
          <div style={styles.desktopDockInner}>
            {dockItems.map(item => {
              const active = pathname === item.to;
              const isChamp = item.to === '/championships';
              return (
                <Link key={item.to} to={item.to} style={styles.dockLink}>
                  <div style={{
                    ...styles.dockIcon,
                    ...(isChamp ? { width: 56, height: 56, marginTop: -16 } : {}),
                    color: active ? '#12d0ff' : '#7881c0',
                    filter: active ? 'drop-shadow(0 0 6px rgba(18, 208, 255, 0.6))' : 'none',
                  }}>
                    {item.icon}
                  </div>
                  {item.label && (
                    <span style={{
                      ...styles.dockLabel,
                      color: active ? '#12d0ff' : '#7881c0',
                    }}>
                      {item.label}
                    </span>
                  )}
                  {active && <div style={styles.dockActiveBarBottom} />}
                </Link>
              );
            })}
          </div>
        </nav>
      </header>

      {/* ═══ MOBILE: Top bar with hamburger ═══ */}
      <header ref={mobRef} className="hide-desktop" style={{
        ...styles.mobileTopBar,
        top: bannerOffset,
        ...(scrolled || megaOpen ? styles.mobileTopBarScrolled : {}),
      }}>
        <div className="nav-mobile-inner" style={styles.mobileTopInner}>
          <Link to="/" style={{ ...styles.logo, minWidth: 0 }}>
            <img src="/assets/whapaxx-logo-transparent.png" alt="Whapaxx Gaming" style={styles.logoImg} />
            <div className="nav-logo-words" style={styles.logoTextWrap}>
              <span className="nav-logo-text" style={styles.logoText}>WHAPAXX</span>
              <span className="nav-logo-sub" style={styles.logoSub}>GAMING</span>
            </div>
          </Link>

          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0 }}>
            <LiveStatus variant="compact" />
            <button
              onClick={() => setMegaOpen(v => !v)}
              aria-label="Toggle menu"
              style={styles.burger}
            >
              <span style={{
                ...styles.burgerLine,
                transform: megaOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none',
              }} />
              <span style={{
                ...styles.burgerLine,
                opacity: megaOpen ? 0 : 1,
              }} />
              <span style={{
                ...styles.burgerLine,
                transform: megaOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none',
              }} />
            </button>
          </div>
        </div>
      </header>

      {/* ═══ MOBILE: Full-screen mega menu ═══ */}
      {megaOpen && (
        <div className="hide-desktop wpxg-scrim-tint" style={{
          '--wpxg-scrim-under': 'rgba(5, 8, 31, 0.98)',
          ...styles.megaOverlay,
          paddingTop: `calc(6.5rem + ${bannerOffset}px)`,
        }}>
          {/* Scanline effect */}
          <div style={styles.megaScanlines} />

          {/* Grid of nav tiles */}
          <div style={styles.megaGrid}>
            {mobileItems.map((item, i) => {
              const active = pathname === item.to;
              const isChamp = item.to === '/championships';
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  style={{
                    ...styles.megaTile,
                    animationDelay: `${i * 0.04}s`,
                    borderColor: active ? `${item.color}60` : 'rgba(18, 208, 255, 0.1)',
                    background: active
                      ? `linear-gradient(135deg, ${item.color}15 0%, transparent 60%)`
                      : 'rgba(11, 18, 71, 0.5)',
                  }}
                >
                  <div style={{
                    ...styles.megaTileIcon,
                    ...(isChamp ? { width: '100%', height: '100%', maxHeight: 56, padding: 4 } : {}),
                    color: active ? item.color : '#a8b2ff',
                    filter: active ? `drop-shadow(0 0 8px ${item.color}80)` : 'none',
                  }}>
                    {item.icon}
                  </div>
                  {item.label && (
                    <span style={{
                      ...styles.megaTileLabel,
                      color: active ? item.color : '#a8b2ff',
                    }}>
                      {item.label}
                    </span>
                  )}
                  {active && (
                    <div style={{
                      ...styles.megaTileActiveIndicator,
                      background: item.color,
                      boxShadow: `0 0 8px ${item.color}`,
                    }} />
                  )}
                </Link>
              );
            })}
          </div>

          {/* Bottom section: Download + Live Status */}
          <div style={styles.megaBottom}>
            <StoreLinks variant="smart" label="Download App" />
          </div>
        </div>
      )}

      {/* Scoped CSS */}
      <style>{`
        @keyframes megaTileIn {
          from { opacity: 0; transform: translateY(12px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </>
  );
}

const styles = {
  /* ── Desktop header ── */
  desktopHeader: {
    position: 'fixed',
    top: 0, left: 0, right: 0,
    zIndex: 1000,
    transition: 'all 0.4s ease',
    background: 'rgba(5, 8, 31, 0.85)',
    backdropFilter: 'blur(24px)',
    borderBottom: '1px solid rgba(18, 208, 255, 0.08)',
  },
  desktopHeaderScrolled: {
    background: 'rgba(5, 8, 31, 0.95)',
    borderBottom: '1px solid rgba(18, 208, 255, 0.12)',
    boxShadow: '0 2px 20px rgba(0, 0, 0, 0.3)',
  },
  desktopTopRow: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0.5rem clamp(1rem, 4vw, 2rem)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  desktopDock: {
    borderTop: '1px solid rgba(18, 208, 255, 0.06)',
    background: 'rgba(18, 208, 255, 0.02)',
  },
  desktopDockInner: {
    maxWidth: '800px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '0.3rem 0.5rem',
  },

  /* ── Desktop dock items ── */
  dockLink: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
    textDecoration: 'none',
    padding: '4px 8px',
    position: 'relative',
    transition: 'all 0.2s ease',
  },
  dockIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
  },
  dockLabel: {
    fontFamily: "'Rajdhani', sans-serif",
    fontSize: '0.7rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    transition: 'color 0.2s ease',
    whiteSpace: 'nowrap',
  },
  dockActiveBarBottom: {
    position: 'absolute',
    bottom: '-4px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '16px',
    height: '2px',
    background: '#12d0ff',
    borderRadius: '1px',
    boxShadow: '0 0 8px rgba(18, 208, 255, 0.6)',
  },

  /* ── Mobile top bar ── */
  mobileTopBar: {
    position: 'fixed',
    top: 0, left: 0, right: 0,
    zIndex: 1001,
    padding: '0.6rem 0',
    transition: 'all 0.4s ease',
    background: 'transparent',
  },
  mobileTopBarScrolled: {
    background: 'rgba(5, 8, 31, 0.95)',
    backdropFilter: 'blur(20px)',
    borderBottom: '1px solid rgba(18, 208, 255, 0.08)',
    padding: '0.4rem 0',
  },
  mobileTopInner: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 clamp(1rem, 4vw, 2rem)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  /* ── Hamburger button ── */
  burger: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    padding: '6px',
  },
  burgerLine: {
    display: 'block',
    width: '24px',
    height: '2px',
    background: '#12d0ff',
    transition: 'all 0.3s ease',
    boxShadow: '0 0 5px rgba(18, 208, 255, 0.5)',
  },

  /* ── Full-screen mega menu overlay ── */
  megaOverlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 1000,
    background: 'rgba(5, 8, 31, 0.98)',
    backdropFilter: 'blur(30px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '6.5rem 1.5rem 2rem',
    overflow: 'auto',
  },
  megaScanlines: {
    position: 'absolute',
    inset: 0,
    backgroundImage:
      'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(18, 208, 255, 0.015) 2px, rgba(18, 208, 255, 0.015) 4px)',
    pointerEvents: 'none',
  },

  /* ── Tile grid ── */
  megaGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '0.75rem',
    width: '100%',
    maxWidth: '360px',
    position: 'relative',
    zIndex: 1,
  },
  megaTile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    padding: '1.25rem 0.75rem',
    border: '1px solid',
    textDecoration: 'none',
    clipPath: 'polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))',
    transition: 'all 0.2s ease',
    position: 'relative',
    animation: 'megaTileIn 0.3s ease-out both',
  },
  megaTileIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
  },
  megaTileLabel: {
    fontFamily: "'Orbitron', sans-serif",
    fontSize: '0.65rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    textAlign: 'center',
  },
  megaTileActiveIndicator: {
    position: 'absolute',
    top: '6px',
    right: '6px',
    width: '6px',
    height: '6px',
    borderRadius: '50%',
  },

  /* ── Bottom section of mega menu ── */
  megaBottom: {
    marginTop: '2rem',
    textAlign: 'center',
    position: 'relative',
    zIndex: 1,
  },

  /* ── Desktop "Gift Cards" link (top bar) ── */
  giftCardsLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.45rem',
    textDecoration: 'none',
    fontFamily: "'Orbitron', sans-serif",
    fontSize: '0.7rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    color: '#fff',
    padding: '0.55rem 1.1rem',
    background: 'linear-gradient(135deg, #7b2dff, #5b21b6)',
    border: '1px solid rgba(123, 45, 255, 0.6)',
    borderRadius: '6px',
    clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px))',
    boxShadow: '0 0 14px rgba(123, 45, 255, 0.35), inset 0 1px 0 rgba(255,255,255,0.1)',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap',
  },
  giftCardsLinkActive: {
    background: 'linear-gradient(135deg, #9b5cff, #7c3aed)',
    borderColor: 'rgba(155, 92, 255, 0.8)',
    boxShadow: '0 0 20px rgba(123, 45, 255, 0.5), inset 0 1px 0 rgba(255,255,255,0.15)',
  },

  /* ── Desktop "Event Packages" link (top bar) ── */
  bookingsLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.45rem',
    textDecoration: 'none',
    fontFamily: "'Orbitron', sans-serif",
    fontSize: '0.7rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    color: '#fff',
    padding: '0.55rem 1.1rem',
    /* Hot pink, the brand's second colour — it used to be a violet a shade
       away from Gift Cards' purple, and the two read as one button. */
    background: 'linear-gradient(135deg, #ff2d78, #c2185b)',
    border: '1px solid rgba(255, 45, 120, 0.6)',
    borderRadius: '6px',
    clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px))',
    boxShadow: '0 0 14px rgba(255, 45, 120, 0.35), inset 0 1px 0 rgba(255,255,255,0.1)',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap',
  },
  bookingsLinkActive: {
    background: 'linear-gradient(135deg, #ff5a9d, #e91e63)',
    borderColor: 'rgba(255, 90, 157, 0.8)',
    boxShadow: '0 0 20px rgba(255, 45, 120, 0.5), inset 0 1px 0 rgba(255,255,255,0.15)',
  },

  /* ── Desktop "Summer Day Pass" link (top bar) ── */
  summerPassLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.45rem',
    textDecoration: 'none',
    fontFamily: "'Orbitron', sans-serif",
    fontSize: '0.7rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    color: '#fff',
    padding: '0.55rem 1.1rem',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    border: '1px solid rgba(245, 158, 11, 0.6)',
    borderRadius: '6px',
    clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px))',
    boxShadow: '0 0 14px rgba(245, 158, 11, 0.35), inset 0 1px 0 rgba(255,255,255,0.1)',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap',
  },
  summerPassLinkActive: {
    background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
    borderColor: 'rgba(251, 191, 36, 0.8)',
    boxShadow: '0 0 20px rgba(245, 158, 11, 0.5), inset 0 1px 0 rgba(255,255,255,0.15)',
  },

  /* ── Shared ── */
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    textDecoration: 'none',
  },
  logoImg: {
    width: '36px',
    height: '36px',
    objectFit: 'contain',
    filter: 'drop-shadow(0 0 8px rgba(18, 208, 255, 0.4))',
  },
  logoTextWrap: {
    display: 'flex',
    flexDirection: 'column',
  },
  logoText: {
    fontFamily: "'Orbitron', sans-serif",
    fontWeight: 800,
    fontSize: '1.1rem',
    letterSpacing: '0.15em',
    color: '#eaf2ff',
  },
  logoSub: {
    fontFamily: "'Orbitron', sans-serif",
    fontWeight: 400,
    fontSize: '0.5rem',
    letterSpacing: '0.3em',
    color: '#12d0ff',
    marginTop: '-2px',
  },
};
